const parseUrl = (href: string) => {
  if (!href) {
    return {
      as: 'div' as unknown as undefined,
    } as const;
  }

  const domain = 'fieldroutes.com';

  if (href[0] === '/') {
    href = `https://www.${domain}${href}`;
  }

  let url: URL;

  try {
    url = new URL(href);
  } catch (err) {
    return {
      as: 'div' as unknown as undefined,
    } as const;
  }

  const isInternalLink = url.hostname === `www.${domain}` || url.hostname === domain;

  return {
    to: isInternalLink ? url.href.split(url.host)[1] : undefined,
    rel: isInternalLink ? '' : 'noreferrer noopener',
    target: isInternalLink || href.startsWith('javascript:') ? '' : '_blank',
    ...(isInternalLink ? {} : { href }),
  };
};

export default parseUrl;
